export default __webpack_public_path__ + "static/meditation-app-design-cover-f5b455766b2c9a6e697cef83f2d821f4.png";